import React from "react";
import { ContenedorBotonSlider } from "./FlechasSliderStyled";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/pro-light-svg-icons";
export var FlechasSliders = function (_a) {
    var estilosFlechas = _a.estilosFlechas;
    return (React.createElement(ContenedorBotonSlider, { className: "splide__arrows", posicion: estilosFlechas === null || estilosFlechas === void 0 ? void 0 : estilosFlechas.position, color: estilosFlechas === null || estilosFlechas === void 0 ? void 0 : estilosFlechas.color },
        React.createElement("button", { className: "splide__arrow splide__arrow--prev", "aria-label": "Elemento Previo" },
            React.createElement(FontAwesomeIcon, { icon: faChevronRight })),
        React.createElement("button", { className: "splide__arrow splide__arrow--next", "aria-label": "Pr\u00F3ximo Elemento" },
            React.createElement(FontAwesomeIcon, { icon: faChevronRight }))));
};
